module.exports = __webpack_public_path__ + "media/images/lp_v6_border-ea2fad48b3bb3ec7d82e193eab811613.webp";